// ============================================
// ENUMS
// ============================================
export var OrderStatus;
(function (OrderStatus) {
    OrderStatus["DRAFT"] = "draft";
    OrderStatus["PAYMENT_PENDING"] = "payment_pending";
    OrderStatus["PENDING"] = "pending";
    OrderStatus["QUOTED"] = "quoted";
    OrderStatus["CONFIRMED"] = "confirmed";
    OrderStatus["PRODUCTION"] = "production";
    OrderStatus["SHIPPED"] = "shipped";
    OrderStatus["DELIVERED"] = "delivered";
    OrderStatus["CANCELLED"] = "cancelled";
    OrderStatus["FAILED"] = "failed";
})(OrderStatus || (OrderStatus = {}));
export var ItemStatus;
(function (ItemStatus) {
    ItemStatus["PENDING"] = "pending";
    ItemStatus["UPLOADED"] = "uploaded";
    ItemStatus["PRINT_READY"] = "print_ready";
    ItemStatus["PROCESSING"] = "processing";
    ItemStatus["COMPLETED"] = "completed";
    ItemStatus["FAILED"] = "failed";
})(ItemStatus || (ItemStatus = {}));
